export default __webpack_public_path__ + "static/media/Lobby4.b427be71.png";